import {WidgetEventStruct} from '../../widget-event.struct';
import {FirmwareWidgetEnum, LogWidgetEnum} from '../../../enums';

export class LogWidgetEventStruct extends WidgetEventStruct {
  public event_log_widget_type: LogWidgetEnum;
} // end Package
